// @flow
import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement,
  injectStripe,
} from 'react-stripe-elements';
import type { StripeCreditCardType, cardValidationStatusType } from '../../utils/types';

type Props = {
  name: string,
  cardValidationStatus: cardValidationStatusType,
  creditCardErrorFields: Array<string>,
  stripe: Object,
  handlePrevClick: Function,
  handleSubmitClick: (card: StripeCreditCardType) => void,
  handleCreditCardDataChange: (e: SyntheticInputEvent<HTMLInputElement>, field: string) => void,
  toggleSpinner: () => void,
  setMessage: (text: string, type?: string) => void,
};

const CreditCardForm = (props: Props) => {
  const handleSubmitClick = (e: SyntheticEvent<HTMLButtonElement>): void => {
    e.preventDefault();

    const creditCardValidationError =
      props.creditCardErrorFields.length || Object.values(props.cardValidationStatus).filter(value => !value).length;

    if (creditCardValidationError) {
      return highlightCreditCardErrorFields();
    }

    props.toggleSpinner();

    props.stripe.createToken({ type: 'card', name: props.name }).then(response => {
      if (response.error && response.error.type === 'card_error') {
        props.toggleSpinner();

        return props.setMessage('Sorry, your payment card has been declined. Please review and try again.', 'danger');
      }

      return props.handleSubmitClick({ stripe_token: response.token.id });
    });
  };

  const highlightCreditCardErrorFields = () => {
    const fields = document.querySelectorAll('.StripeElement--empty');

    if (fields.length) {
      for (let field of fields) {
        field.classList.add('error');
      }
    }
  };

  return (
    <div>
      <h3>Payment Information</h3>

      <Row className="show-grid">
        <div className="str-grid">
          <CardNumberElement
            className="str-number"
            onChange={e => props.handleCreditCardDataChange(e, 'number')}
            placeholder="Card number"
          />

          <CardExpiryElement
            className="str-date"
            onChange={e => props.handleCreditCardDataChange(e, 'expiration_date')}
            placeholder="Expiration date"
          />

          <CardCVCElement
            className="str-cvv"
            onChange={e => props.handleCreditCardDataChange(e, 'cvc')}
            placeholder="CVV"
          />

          <PostalCodeElement
            className="str-zip"
            onChange={e => props.handleCreditCardDataChange(e, 'zipcode')}
            placeholder="ZIP code"
          />

          <div className="form-footer">
            <Col md={6} className="link-info">
              <a className="info-prev" onClick={() => props.handlePrevClick()}>
                Previous Step
              </a>
            </Col>
            <Col md={6} className="info-button">
              <Button bsStyle="primary" onClick={handleSubmitClick}>
                Register
              </Button>
            </Col>
          </div>
        </div>
      </Row>
    </div>
  );
};

export default injectStripe(CreditCardForm);



// WEBPACK FOOTER //
// ./src/components/Register/CreditCardForm.js